import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsScreenEvent } from '../../types';
import { type CommonAttributes } from './types';

type onDropdownViewedArgs = {
	commonAttributes: CommonAttributes;
};

export const onDropdownViewed = ({
	commonAttributes,
}: onDropdownViewedArgs): FireAnalyticsScreenEvent => ({
	name: `${ACTION_SUBJECT_PREFIX}Dropdown`,
	attributes: {
		commonAttributes,
	},
});
